import { Link } from "react-router-dom";
import { Check, ArrowRight, Trees, Axe, Mountain, Waves, Route, Hammer } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import { SERVICES } from "@/lib/siteData";

const ICONS = { Trees, Axe, Mountain, Waves, Route, Hammer };

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title="Six services. One team that does them right."
        subtitle="From a single overgrown lot to a multi-acre development pad, we bring the right machine, the right operator, and dependable service you can count on."
        image="https://images.pexels.com/photos/11118633/pexels-photo-11118633.jpeg"
      />

      <section className="bg-[#F9F8F6] py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <div className="space-y-20 md:space-y-28">
            {SERVICES.map((s, idx) => {
              const Icon = ICONS[s.icon] || Trees;
              const reverse = idx % 2 === 1;
              return (
                <article
                  key={s.slug}
                  id={s.slug}
                  data-testid={`service-section-${s.slug}`}
                  className="grid items-center gap-10 md:grid-cols-2 md:gap-16"
                >
                  <div className={`relative aspect-[4/3] overflow-hidden bg-[#E8E2DA] ${reverse ? "md:order-2" : ""}`}>
                    <img
                      src={s.image}
                      alt={s.title}
                      className="h-full w-full object-cover"
                      loading="lazy"
                    />
                    <div className="absolute left-0 top-0 bg-[#16302B] px-4 py-2 text-[10px] font-bold uppercase tracking-[0.22em] text-[#D95D39]">
                      0{idx + 1} / {SERVICES.length}
                    </div>
                  </div>

                  <div>
                    <div className="flex items-center gap-3">
                      <span className="grid h-11 w-11 place-items-center bg-[#16302B] text-[#D95D39]">
                        <Icon size={20} strokeWidth={2} />
                      </span>
                      <p className="eyebrow">{s.short}</p>
                    </div>
                    <h2 className="mt-5 font-display text-3xl font-black tracking-tight text-[#16302B] sm:text-4xl">
                      {s.title}
                    </h2>
                    <p className="mt-5 text-base leading-relaxed text-[#5C5C5C] md:text-lg">{s.description}</p>

                    <ul className="mt-7 grid gap-3 sm:grid-cols-2">
                      {s.bullets.map((b) => (
                        <li key={b} className="flex items-start gap-2 text-sm text-[#1C1C1C]">
                          <Check size={16} strokeWidth={3} className="mt-0.5 text-[#D95D39]" />
                          {b}
                        </li>
                      ))}
                    </ul>

                    <Link
                      to="/contact"
                      data-testid={`service-cta-${s.slug}`}
                      className="mt-8 inline-flex items-center gap-2 bg-[#16302B] px-6 py-3 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-[#20443D]"
                    >
                      Quote this service <ArrowRight size={14} strokeWidth={2.5} />
                    </Link>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
